import { useEffect, useState } from "react";
import { MONTH_NAMES } from "../../utils/constants";

interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const useCountdown = (targetDay: number, description: string) => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const [targetMonthYear, setTargetMonthYear] = useState<string>("");

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      let targetDate = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        targetDay,
        23,
        59,
        59,
        999,
      );

      if (now > targetDate) {
        if (now.getMonth() === 11 && now.getDate() > targetDay) {
          targetDate = new Date(now.getFullYear() + 1, 0, targetDay);
        } else if (now.getDate() > targetDay) {
          targetDate = new Date(
            now.getFullYear(),
            now.getMonth() + 1,
            targetDay,
          );
        }
      }

      let nextMonthIndex = targetDate.getMonth() + 1;
      let nextYear = targetDate.getFullYear();

      if (nextMonthIndex > 11) {
        nextMonthIndex = 0;
        nextYear += 1;
      }

      const targetMonth = MONTH_NAMES[nextMonthIndex];
      const targetYear = nextYear;
      setTargetMonthYear(`${description} (${targetMonth} ${targetYear}), em:`);

      const difference = targetDate.getTime() - now.getTime();
      setTimeLeft({
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      });
    };

    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [targetDay, description]);

  return { timeLeft, targetMonthYear };
};

export default useCountdown;
